// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"160":"dedicated-nodes","242":"solutions","376":"polygon","524":"bsc","631":"contact"}[chunkId] + "." + {"160":"cab57256","242":"83b6cf1b","376":"dc394051","524":"45d70ff0","631":"cab57256"}[chunkId] + ".css";
};